<template>
  <div class="section-main__warp" style="margin-top: 0px;">
    <div class="fuel-use-list">
      <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
        @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        <template slot="search_year">
          <el-date-picker v-model="yearId" type="year" value-format="yyyy" placeholder="选择年"></el-date-picker>
        </template>
        <template slot="menuLeft">
          <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
            新增
          </el-button>
        </template>
        <template slot="consumption" slot-scope="scope">
          {{ consumptionRender(scope.row.consumption) }}
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-edit-outline" @click="handleUdp(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
        </template>
      </ioc-table>
      <el-dialog :title="dialogTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
        width="35%">
        <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
          <el-form-item label="年份" prop="year">
            <el-date-picker v-model="addForm.year" type="year" value-format="yyyy" placeholder="选择年" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="月份" prop="month">
            <el-date-picker v-model="addForm.month" type="month" format="MM" value-format="MM" placeholder="选择月"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="fuelType == '1'" label="消耗量(t)" prop="consumption">
            <el-input v-model="addForm.consumption" placeholder="请输入" @input="calculateCount"></el-input>
          </el-form-item>
          <el-form-item v-else-if="fuelType == '2'" label="消耗量(m³)" prop="consumption">
            <el-input v-model="addForm.consumption" placeholder="请输入" @input="calculateCount"></el-input>
          </el-form-item>
          <el-form-item v-else label="消耗量" prop="consumption">
            <el-input v-model="addForm.consumption" placeholder="油的单位为吨；天然气单位为立方米" @input="calculateCount"></el-input>
          </el-form-item>
          <el-form-item label="排放量(kgCo2)" prop="carbonEmission">
            <el-input v-model="addForm.carbonEmission" readonly></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="addForm.remark" placeholder="请输入" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
          <el-button @click="addCancel('addForm')">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/fuelUse";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      yearId: null,
      option: tableOption(),
      tableData: [],
      searchForm: {},
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        year: [{ required: true, message: '请选择年', trigger: ['blur', 'change'] }],
        month: [{ required: true, message: '请选择月', trigger: ['blur', 'change'] }],
        consumption: [{ required: true, message: '请输入消耗量', trigger: ['blur', 'change'] }],
        carbonEmission: [{ required: true, message: '请输入排放量', trigger: ['blur', 'change'] }],
      },
      dialogTitle: '',
      addVisible: false,
      modalClose: false,
      addForm: {
        id: null,
        year: '',
        month: '',
        consumption: '',
        carbonEmission: '',
        remark: ''
      },
      leftId: null,
      fuelType: null
    };
  },
  methods: {
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.yearId = null
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList(id, type) {
      if (id) {
        this.leftId = id
      }
      if (type) {
        this.fuelType = type
      }
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        year: this.yearId,
        fuel: this.leftId
      };
      this.$fetch(api.fuelConsumption.queryFuelUse, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    consumptionRender(data) {
      if (this.fuelType == '1') {
        return data + ' t'
      } else if (this.fuelType == '2') {
        return data + ' m³'
      } else {
        return data
      }
    },
    handleAdd() {
      this.dialogTitle = '新增燃料排放'
      this.addForm.id = null
      this.addForm.year = ''
      this.addForm.month = ''
      this.addForm.consumption = ''
      this.addForm.carbonEmission = ''
      this.addForm.remark = ''
      this.addVisible = true;
    },
    addCancel(formName) {
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.id) {
            let params = {
              fuel: this.leftId,
              id: this.addForm.id,
              year: this.addForm.year,
              month: this.addForm.month,
              consumption: this.addForm.consumption,
              carbonEmission: this.addForm.carbonEmission,
              remark: this.addForm.remark
            }
            this.$fetch(api.fuelConsumption.updateFuelInfo, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              fuel: this.leftId,
              year: this.addForm.year,
              month: this.addForm.month,
              consumption: this.addForm.consumption,
              carbonEmission: this.addForm.carbonEmission,
              remark: this.addForm.remark
            }
            this.$fetch(api.fuelConsumption.addFuelInfo, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    // 修改
    handleUdp(row) {
      this.dialogTitle = '修改燃料排放'
      this.addForm.id = row.id
      this.addForm.year = row.year
      this.addForm.month = row.month
      this.addForm.consumption = row.consumption
      this.addForm.carbonEmission = row.carbonEmission
      this.addForm.remark = row.remark
      this.addVisible = true;
    },
    calculateCount(value) {
      this.$fetch(api.fuelConsumption.queryFuelById, {
        id: this.leftId
      }).then((response) => {
        if (response.success) {
          let tempData = response.returnObj.emissionFuel
          if (tempData.fuelUnit == '10^4Nm³') {
            this.addForm.carbonEmission = (value / 10000 * tempData.lowerHeating * tempData.oxidationRate * tempData.carbonUnitHeating * tempData.molecularWeight * 1000).toFixed(4)
          } else if (tempData.fuelUnit == 'T') {
            this.addForm.carbonEmission = (value * tempData.lowerHeating * tempData.oxidationRate * tempData.carbonUnitHeating * tempData.molecularWeight * 1000).toFixed(4)
          }
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    // 删除
    handleDel(row) {
      let params = {
        id: row.id
      }
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.fuelConsumption.delFuelInfo, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fuel-use-list {
  width: 100%;
  height: calc(100vh - 115px);
}
</style>